import ChatCard from '../ChatCard'
import { Button } from '@/shared/ui/button.tsx'
import ThemeDetailsCard from '../ThemeDetailsCard'
import { Card } from '@/shared/ui/card.tsx'
import { cn } from '@/lib/utils'
import { useState } from 'react'
import { filterPlatformsByPosts, getPlatformPostsNew } from '@/lib/review-fn'
import { ChatMessageType, SocialPostType } from '../../types'
import { ChevronLeft, ChevronRight, Home, Sparkles } from 'lucide-react'
import { SetStateAction } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { toast } from 'sonner'

const platforms = [
  { id: 1, name: "Instagram", url: "https://cdn.simpleicons.org/instagram" },
  { id: 2, name: "Facebook", url: "https://cdn.simpleicons.org/facebook" },
  { id: 3, name: "X", url: "https://cdn.simpleicons.org/x" },
  { id: 4, name: "Linkedin", url: "https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9P0XaqmMB6Kayu3FZoPe1vCJnV7chgTXlAdkM" },
  { id: 5, name: "LinkedIn", url: "https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9P0XaqmMB6Kayu3FZoPe1vCJnV7chgTXlAdkM" },
  { id: 6, name: "Pinterest", url: "https://cdn.simpleicons.org/pinterest" },
]

type Props = {
  setStep: (id: ChatMessageType) => void,
  selectedTheme: number | undefined,
  setMessage: (text: string, user: string) => void,
  setCanReturn: React.Dispatch<SetStateAction<boolean>>,
  themeDetailData: {
    data: {
      event_id: number;
      story_id: number | null;
      event: string;
      status: number;
      content: SocialPostType[];
    },
    introduction: string;
  }
}

const ThemePostResult = ({ setStep, setMessage, themeDetailData, setCanReturn }: Props) => {

  if(themeDetailData.data.content.length === 0 || themeDetailData.data === null){

    toast.message("No content for the event")

    return <Navigate to=".." />
  }

  const [currentContent, setCurrentContent] = useState(0)

  const filteredPlatforms = filterPlatformsByPosts(themeDetailData.data.content, platforms)

  if (filteredPlatforms.length === 1) {
    setCanReturn(false)
  }

  const navigate = useNavigate()

  const [showPrompt, setShowPrompt] = useState(false)

  return (
    <>
      <ChatCard user="client">
        <div className="w-full flex justify-between flex-col-reverse sm:flex-row items-end sm:items-center gap-3">

          <div className='flex items-center gap-1'>
            <Button
              onClick={() => setStep("navigation")}
              variant="outline"
              size="icon"
              className="rounded-full font-poppins border-2 border-purple-400 hover:bg-white tracking-wide text-purple-600"
            >
              <Home />
            </Button>
            <Button
              onClick={() => {
                navigate(-1)
                // if (themeDetailData.data.status === 1) {
                //   setStep("first")
                // } else {
                //   setStep("campaign")
                // }
              }}
              variant="outline"
              className="rounded-full font-poppins border-2 border-purple-400 hover:bg-white tracking-wide text-purple-600"
            >
              Return to {themeDetailData.data.status === 1 ? "Theme" : themeDetailData.data.status === 4 ? "Create Theme" : "Campaign"}
            </Button>
          </div>
          <p className="tracking-wide text-gray-500 font-poppins text-sm max-sm:pt-2">I want to checkout {themeDetailData.data.event}</p>
        </div>
      </ChatCard>
      <ChatCard user="assistant">
        <div className="w-full flex flex-col gap-4">

          <p className="w-full tracking-wide text-gray-500 font-poppins text-sm">{themeDetailData.introduction}</p>
          <ThemeDetailsCard
            story_id={themeDetailData.data.story_id}
            setMessage={setMessage}
            platform={filteredPlatforms[currentContent]}
            event_id={themeDetailData.data.event_id}
            status={themeDetailData.data.status}
            event_name={themeDetailData.data.event}
            data={getPlatformPostsNew(filteredPlatforms[currentContent].name, themeDetailData.data.content)[0]}
            showPrompt={showPrompt}
            setShowPrompt={setShowPrompt}
            setStep={setStep}
            filteredPlatforms={filteredPlatforms}
          />
          <div className="flex items-center justify-between w-full">
            <div className="flex flex-1 items-center gap-2">
              <Card
                onClick={() => {
                  setCurrentContent(prev => (prev - 1 + filteredPlatforms.length) % filteredPlatforms.length)
                }}
                className="flex-1 border gap-2 h-10 cursor-pointer border-purple-300 flex items-center justify-center rounded-full">
                <ChevronLeft className='block sm:hidden' />
                <img src={filteredPlatforms[(currentContent - 1 + filteredPlatforms.length) % filteredPlatforms.length].url} className="size-4" />
                <p className={cn("font-poppins text-sm hidden tracking-wider sm:flex items-center gap-2")}>
                  Previous Platform</p>
              </Card>

              <Card
                className="flex-1 border gap-2 h-10 cursor-pointer border-purple-300 flex items-center justify-center rounded-full"
                onClick={() => setShowPrompt(prev => !prev)}>
                <p className="font-poppins text-[0.6rem] sm:text-sm tracking-wider">{showPrompt ? "Back to Content" : "Reimagine"}</p>
                <Sparkles size={14} />
              </Card>
              <Card
                onClick={() => {
                  setCurrentContent(prev => (prev + 1) % filteredPlatforms.length)
                }}
                className="flex-1 border gap-2 h-10 cursor-pointer border-purple-300 flex items-center justify-center rounded-full">
                <img src={filteredPlatforms[(currentContent + 1) % filteredPlatforms.length].url} className="size-4" />
                <p className={cn("font-poppins text-sm sm:flex hidden tracking-wider items-center gap-2")}>
                  Next Platform</p>
                <ChevronRight className='block sm:hidden' />
              </Card>
            </div>
          </div>
        </div>
      </ChatCard>
    </>
  )
}

export default ThemePostResult;
